import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { ClickMarketTrendsLink_ForYouHeuristic } from '@sorare/core/src/protos/events/platform/web/events';

import { PlayerRecommendationRow } from 'components/forYou/PlayerRecommendationRow';
import { HotStreakChip } from 'components/forYou/chips/HotStreakChip';

import { NoWrap } from '../ui';
import { HotStreak_so5League } from './__generated__/index.graphql';

type Props = {
  so5League: Nullable<HotStreak_so5League>;
  loading: boolean;
  onStatsClick: (slug: string) => void;
  so5LeagueSlug: string;
};

export const HotStreak = ({
  so5League,
  loading,
  onStatsClick,
  so5LeagueSlug,
}: Props) => {
  const players =
    so5League?.hotStreak
      ?.map(({ anyPlayer }) => anyPlayer)
      .filter(Boolean)
      .slice(0, 5) || [];

  return (
    <PlayerRecommendationRow
      title={
        <FormattedMessage
          defaultMessage="Players{br}on a Hot <noWrap>Streak</noWrap>"
          id="market.trending.forYou.hotStreak.title"
          values={{
            br: <br />,
            noWrap: chunks => <NoWrap>{chunks}</NoWrap>,
          }}
        />
      }
      chip={<HotStreakChip />}
      loading={loading}
      players={players}
      onStatsClick={onStatsClick}
      eventProperties={{
        heuristic: ClickMarketTrendsLink_ForYouHeuristic.HOT_STREAK,
        so5LeagueSlug,
      }}
    />
  );
};

HotStreak.fragments = {
  so5League: gql`
    fragment HotStreak_so5League on So5League {
      slug
      hotStreak: topRecommendations(
        recommendationEngine: HOT_STREAK
        sport: $sport
        positions: $positions
      ) {
        id
        playerSlug
        anyPlayer {
          slug
          ...PlayerRecommendationRow_anyPlayer
        }
      }
    }
    ${PlayerRecommendationRow.fragments.anyPlayer}
  ` as TypedDocumentNode<HotStreak_so5League>,
};
